/** Section shown inside the settings modal. Matches the Release 1 nav ids. */
export enum SettingsModalSection {
  Preferences = 'preferences',
  ConnectedAccounts = 'connected-accounts',
  Subscription = 'subscription',
  CreateOrganization = 'create-organization',
  Members = 'members',
  Billing = 'billing',
}

/** Separates the open that revealed a section from a later change inside the same open. */
export enum SettingsViewTrigger {
  Open = 'open',
  SectionChange = 'section_change',
}
